export default [
    {
        path: '/pages/order/storeOrderCart',
        name: '/pages/order/storeOrderCart',
        meta: { title: '订单信息' },
        component: () => import('@/views/order/storeOrderCart.vue')
    },
    {
        path: '/pages/order/storeOrderCartFee',
        name: '/pages/order/storeOrderCartFee',
        meta: { title: '订单费用' },
        component: () => import('@/views/order/storeOrderCartFee.vue')
    },
    {
        path: '/pages/order/storeOrderCartReturn',
        name: '/pages/order/storeOrderCartReturn',
        meta: { title: '退货订单' },
        component: () => import('@/views/order/storeOrderCartReturn.vue')
    },
    {
        path: '/pages/order/storeOrderLogistics',
        name: '/pages/order/storeOrderLogistics',
        meta: { title: '订单物流' },
        component: () => import('@/views/order/storeOrderLogistics.vue')
    },
    {
        path: '/pages/order/aOrderDetail',
        name: '/pages/order/aOrderDetail',
        component: () => import('@/views/order/aOrderDetail.vue')
    },
    {
        path: '/pages/order/businessCenter',
        name: '/pages/order/businessCenter',
        component: () => import('@/views/order/businessCenter.vue')
    },
    {
        path: '/pages/order/orderWriteOffConfirm',
        name: '/pages/order/orderWriteOffConfirm',
        meta: { title: '到店核销' },
        component: () => import('@/views/order/orderWriteOffConfirm.vue')
    },
    {
        path: '/pages/order/shopOrder',
        name: '/pages/order/shopOrder',
        component: () => import('@/views/order/shopOrder.vue')
    },
    {
        path: '/pages/order/StockUpStoreOrder',
        name: '/pages/order/StockUpStoreOrder',
        component: () => import('@/views/order/StockUpStoreOrder.vue')
    }
] 